import React from "react";

import svg from "../../assets/images/icons/text_file.svg";

export const TextFileIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Text File"}
    />
);
